import _extends from '@babel/runtime/helpers/extends';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { forwardRef } from 'react';
import { StyledLink, StyledButton } from './Button.styles.js';
import { ButtonType, ButtonSize, ButtonBlock, ButtonStatus, ButtonIconPosition } from './Button.types.js';
import { useDesignSystemThemeName, cleanProps } from '../utils.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var nonNativeProps = ['children', 'themeName', 'blockOn', 'type', 'status', 'size', 'className', 'shape', 'text', 'icon', 'iconLabel', 'iconPosition', 'block', 'htmlType', 'shrink'];
var prefixCls = 'sok-btn';
var Button = /*#__PURE__*/forwardRef(function (props, ref) {
  var ariaLabel = props['aria-label'],
      block = props.block,
      blockOn = props.blockOn,
      children = props.children,
      className = props.className,
      href = props.href,
      htmlType = props.htmlType,
      icon = props.icon,
      iconLabel = props.iconLabel,
      iconPosition = props.iconPosition,
      shape = props.shape,
      shrink = props.shrink,
      size = props.size,
      status = props.status,
      style = props.style,
      text = props.text,
      type = props.type;
  var themeName = useDesignSystemThemeName();
  var shapeClass = "".concat(prefixCls, "-").concat(shape);
  var iconClass = "".concat(prefixCls, "-icon-only");
  var blockClass = "".concat(prefixCls, "-block");
  var shrinkClass = "".concat(prefixCls, "-shrink");
  var classNames = "\n    ".concat(className || '', "\n    sok-btn\n    ").concat(prefixCls, "-").concat(type || 'primary', "\n    ").concat(prefixCls, "-").concat(size || 'large', "\n    ").concat(shape ? shapeClass : '', "\n    ").concat(icon && !text ? iconClass : '', "\n    ").concat(block ? blockClass : '', "\n    ").concat(status, " ").concat(themeName, " ").concat(blockOn, "\n    ").concat(shrink ? shrinkClass : '', "\n  ");

  var componentProps = _objectSpread(_objectSpread({}, cleanProps(props, nonNativeProps)), {}, {
    style: _objectSpread({}, style),
    className: classNames.replace(/\s*\n\s*/g, ' '),
    type: htmlType,
    'aria-label': iconLabel || ariaLabel
  });

  var jsxChildren = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, iconPosition === 'left' && icon ? icon : null, text || children ? /*#__PURE__*/React__default.createElement("span", null, text || children) : null, iconPosition === 'right' && icon ? icon : null);
  return href ? /*#__PURE__*/React__default.createElement(StyledLink, _extends({}, componentProps, {
    ref: ref
  }), jsxChildren) : /*#__PURE__*/React__default.createElement(StyledButton, _extends({}, componentProps, {
    ref: ref
  }), jsxChildren);
});
Button.displayName = 'Button';
Button.defaultProps = {
  type: ButtonType.PRIMARY,
  size: ButtonSize.MIDDLE,
  blockOn: ButtonBlock.NONE,
  status: ButtonStatus.NONE,
  htmlType: 'button',
  'data-test-id': 'Button',
  iconPosition: ButtonIconPosition.LEFT
};

export { Button, Button as default };
//# sourceMappingURL=Button.js.map
